import {
  sendMsg,
  ENDPOINT_REQUEST as userServicesRequest,
  SERVICES_REQUEST as services,
} from "../../configurations";

// Call services to get NEW OTP WITHOUT TOKEN
export const generateNewOTP = (params, callback) => {
  sendMsg(services.SECURE, userServicesRequest.iSEC.GENERATE_NEW_OTP, params).post(
    (res) => {
      callback(res);
    }
  );
};

// Call services to get OTP
export const generateOTP = (params, callback) => {
  sendMsg(services.SECURE, userServicesRequest.iSEC.NEW_OTP, params).post(
    (res) => {
      callback(res);
    }
  );
};

// Call services to verification OTP
export const otpVerification = (params, callback) => {
  sendMsg(services.SECURE, userServicesRequest.iSEC.VERIFY_OTP, params).post(
    (res) => {
      callback(res);
    }
  );
};
// Call services to get SecureRandomCode
export const getSecureRandomCode = (params, callback) => {
  sendMsg(services.EQT, userServicesRequest.iSEC.SECURE_RANDOM_CODE, params).get(res => {
    callback(res);
  })
}